import React from "react";
import { Box, Text, Icon } from "@chakra-ui/react";
import { MdAdminPanelSettings } from "react-icons/md";

/**
 * Builds the header container Chakra style props based on screen size.
 * @param {boolean} isMobile - Whether the viewport is mobile-sized
 * @returns {Object} Chakra style-prop object
 */
function getHeaderContainerProps(isMobile) {
    return {
        p: isMobile ? "24px 20px" : "32px 24px",
        bgGradient: "linear(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%)",
        borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        textAlign: "center"
    };
}

/**
 * Renders the circular admin icon for the login header.
 * @param {Object} props
 * @param {boolean} props.isMobile - Whether the viewport is mobile-sized
 * @returns {React.ReactElement}
 */
function LoginHeaderIcon({ isMobile }) {
    return (
        <Box display="inline-flex" alignItems="center" justifyContent="center"
            w={isMobile ? "60px" : "70px"} h={isMobile ? "60px" : "70px"} borderRadius="50%"
            bgGradient="linear(135deg, rgba(102, 126, 234, 0.3) 0%, rgba(118, 75, 162, 0.3) 100%)"
            border="2px solid rgba(255, 255, 255, 0.1)" mb="16px">
            <Icon as={MdAdminPanelSettings} fontSize={isMobile ? "32px" : "40px"} color="#667eea" />
        </Box>
    );
}

/**
 * Renders the login page header with the admin icon and welcome text.
 * @param {Object} props
 * @param {boolean} props.isMobile - Whether the viewport is mobile-sized
 * @returns {React.ReactElement}
 */
function LoginHeader({ isMobile }) {
    return (
        <Box {...getHeaderContainerProps(isMobile)}>
            <LoginHeaderIcon isMobile={isMobile} />
            <Text color="rgba(255, 255, 255, 0.95)" fontSize={isMobile ? "1.3rem" : "1.5rem"}
                fontWeight={700} mb="4px" letterSpacing="0.5px">
                Espace Admin
            </Text>
            <Text color="rgba(255, 255, 255, 0.6)" fontSize={isMobile ? "0.8rem" : "0.85rem"} fontWeight={500}>
                Connectez-vous pour continuer
            </Text>
        </Box>
    );
}

export default LoginHeader;
